module.exports = __webpack_public_path__ + "static/media/unico-auto-pecas.ccc9bd32.webp";